import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as moment from 'moment';
import { EditPaymentPlanComponent } from './edit-payment-plan/edit-payment-plan.component';
import { CaseService } from 'src/app/services/case.service';

@Component({
  selector: 'app-view-payment-plan',
  templateUrl: './view-payment-plan.page.html',
  styleUrls: ['./view-payment-plan.page.scss'],
})
export class ViewPaymentPlanPage implements OnInit {

  @Input() caseId;
  @Input() currentCase;
  debtorId;
  outstanding;
  currentArrangementString = '';
  currArrangement;
  activeArrangements: any = {
    currentArrangements: {
      show: true,
    },
    scheduleArrangements: {
      show: true,
      data: null,
    },
  };
  frequencies = [
    '',
    '',
    'One time final payment',
    'Weekly by day of the week',
    'Monthly by date',
    'Monthly by day - e.g. "1st friday',
    'Fortnightly',
    '4 weekly',
    'Last day of the month',
    'First day of the month',
    'Last work day of the month',
    'Last Friday of the month',
  ];
  isGroupArrangement = false;
  baseOutstanding;
  dateFormat = 'DD-MM-YYYY';
  currency_symbol;
  freq: string;
  showUpdateOption = false;
  currentPage: number = 1;
  totalPages: number = 1;
  pageSize: number = 10;
  paginatedData = {
    data: [],
    show: true
  };
  constructor(private modalController: ModalController, private caseService: CaseService, private cdr: ChangeDetectorRef) {}

  async ngOnInit() {
    this.caseService.caseDetail$.subscribe(async (updatedCaseData) => {
      if (updatedCaseData) {
        this.currentPage = 1;
        this.currentCase = updatedCaseData;
        this.getActiveArrangements();
        await this.loadPageData(1);
        this.cdr.detectChanges();
      }
    });
    let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    if (portalSettings?.arrangement?.allow_scheduled_payment_update) {
      this.showUpdateOption = true;
    }
  }
  async ionViewWillEnter() {
    await this.getActiveArrangements();
    this.currentPage = 1;
    const callScheduleApi = this.currentCase?.arranagement?.arrangement_schedule ? this.currentCase.arranagement.arrangement_schedule.length <= 0 : 1;
    if (callScheduleApi) {
      await this.caseService.setArrangementPaymentDetails(
        this.caseId,
        this.currentPage,
        this.pageSize
      );
      await this.updatePaginationData();
      await this.processScheduledPaymentsData();
    } else {
      await this.loadPageData(1);
    }
  }

  toggleShow(object) {
    object.show = !object.show;
  }
  isShown(object) {
    return object.show;
  }
  async getActiveArrangements() {
    if (localStorage.getItem('dateFormat'))
      this.dateFormat = localStorage.getItem('dateFormat');
    this.currency_symbol = this.currentCase.currency_symbol;
    this.baseOutstanding = this.outstanding =
      this.currentCase.d_outstanding.replace(
        this.currentCase.currency_symbol,
        ''
      );

    if (this.currentCase.arranagement) {
      this.currArrangement = this.getPaymentArrangementInfo(this.currentCase.arranagement.current_arrangement.length,'arrangement');
    }
    if (this.currentCase.debtorid) {
      this.debtorId = this.currentCase.debtorid;
    }

    if (this.currArrangement)
      this.currArrangement = this.currArrangement.find(
        (data) => data.active == 1
      );

    this.makeCurrentArrangementString();
  }

  async processScheduledPaymentsData() {
    if (this.currArrangement) {
      this.paginatedData.data.forEach(
        (element, index) => {
          this.paginatedData.data[index].date =
            moment(element.date).format(this.dateFormat);
          let amount_paid;
          if (element.arr_balance == 0.0 && element.payment_action.id == -16) {
            amount_paid = element.amount;
          } else if (
            (element.arr_balance > 0.0 && element.payment_action.id == -12) ||
            (element.arr_balance < 0.0 && element.payment_action.id == -8)
          ) {
            amount_paid = element.amount + element.arr_balance;
          } else {
            amount_paid = element.arr_balance;
          }
          this.paginatedData.data[index].arr_balance =
            amount_paid;
        }
      );
    }
  }
  makeCurrentArrangementString() {
    this.currentArrangementString = '';

    let debtor_field = 'defendant';
    let currency_symbol = '&pound;';
    try {
      if (this.currentCase.scheme.scheme_manager.debtor_field) {
        debtor_field = this.currentCase.scheme.scheme_manager.debtor_field;
      }
      currency_symbol = this.currentCase.currency_symbol;
    } catch (error) {}
    if (this.currArrangement) {
      this.currentArrangementString += `The ${debtor_field} agreed to pay `;
      if (
        parseInt(this.currArrangement.first_amount, 10) > 0 &&
        this.currArrangement.first_date
      ) {
        this.currentArrangementString += `initial payment of <strong>${currency_symbol}${
          this.currArrangement.first_amount
        }
        </strong> due on <strong>${moment(
          this.currArrangement.first_date
        ).format(this.dateFormat)}</strong> followed by `;
      }
      this.currentArrangementString += `<strong>${currency_symbol}${
        this.currArrangement.amount
      }</strong> with a <strong>
      ${this.frequencies[this.currArrangement.freq]}</strong> on <strong>
      ${moment(this.currArrangement.start).format(
        this.dateFormat
      )}</strong>.`;
      this.currentArrangementString += ` The next payment is scheduled on
        <strong>${this.currentCase.next_arrangement_payment_date}</strong>.
        </p>`;
      // if (this.isGroupArrangement) {
      //   this.currentArrangementString += `<div>Selected Cases:  ${JSON.parse(
      //     this.currArrangement.caseids
      //   ).join()}</div>`;
      // }
    } else {
      this.currentArrangementString += `The case ${this.caseId} has no arrangement set.`;
    }
  }

  async openModal(scheduledPayment) {
    const modal = await this.modalController.create({
      component: EditPaymentPlanComponent,
      componentProps: {
        scheduledPayment,
        caseId : this.caseId
      }
    });
    await modal.present();
  }

  getPaymentArrangementInfo(arranagementLength, arranagementType) {

    if (arranagementType == 'arrangement' && arranagementLength > 0) {
      return this.currentCase.arranagement.current_arrangement;
    } else if (arranagementType == 'arrangement') {
      return this.currentCase.arranagement.current_group_arrangement;
    }

    if (arranagementType == 'arrangement_schedule' && arranagementLength > 0) {
      return this.currentCase.arranagement.arrangement_schedule;
    } else if (arranagementType == 'arrangement_schedule') {
      return this.currentCase.arranagement.group_arrangement_schedule;
    }
  }

  async goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      await this.loadPageData(this.currentPage);
    }
  }

  async goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      await this.loadPageData(this.currentPage);
    }
  }
  private async loadPageData(page: number) {
    const startIndex = (page - 1) * this.pageSize;
    const endIndex = page * this.pageSize;
    if (this.currentCase.arranagement?.arrangement_schedule && this.currentCase.arranagement.arrangement_schedule.length > startIndex) {
      await this.updatePaginationData();
    } else {
      await this.caseService.setArrangementPaymentDetails(this.caseId, page, this.pageSize);
      await this.updatePaginationData();
      await this.processScheduledPaymentsData();
    }
  }

  async updatePaginationData() {
    this.totalPages = Math.ceil(this.currentCase.arranagement.total_scheduled_payments/this.pageSize);
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = this.currentPage * this.pageSize;

    this.paginatedData.data =
      this.currentCase.arranagement.arrangement_schedule.slice(
        startIndex,
        endIndex
      );

  }
}
